import React, { useState } from 'react';
import { string, element } from 'prop-types';
import { Popover, Button, Typography } from '@one-thd/sui-atomic-components';
import { Info } from '@one-thd/sui-icons';

const ProductAddonsTooltip = React.forwardRef(({ tooltipContent, title, label }, buttonRef) => {

  const [anchorEl, setAnchorEl] = useState(null);
  const [placement, setPlacement] = useState(null);

  const handleClick = (newPlacement) => (event) => {
    setAnchorEl(event.currentTarget);
    setPlacement(newPlacement);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setPlacement(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? `${placement}-popover` : undefined;

  return (
    <>
      <Popover
        open={open}
        id={id}
        anchorEl={anchorEl}
        placement={placement}
        title={title}
        onClose={handleClose}
      >
        <Typography variant="body-base">
          {tooltipContent}
        </Typography>
      </Popover>

      <Button
        variant="text"
        onClick={handleClick('bottom-start')}
        className="sui-underline"
        ref={buttonRef}
      >
        <div className="sui-flex sui-mt-1">
          <div>
            {label || 'What to Expect'}
          </div>
          <div className="sui-ml-1 sui-mt-1"><Info size="small" /></div>
        </div>
      </Button>
    </>

  );
});

ProductAddonsTooltip.displayName = 'ProductAddOns-tooltip';

ProductAddonsTooltip.propTypes = {
  title: string,
  tooltipContent: element,
  label: string
};

ProductAddonsTooltip.defaultProps = {
  title: '',
  tooltipContent: null,
  label: ''
};

export { ProductAddonsTooltip };
